import * as React from "react";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export default function TableDataGrid({data, tableRef}) {
  const columnObject = data.shift();

  const allColKeys = Object.keys(columnObject).filter(k => k.startsWith('col'));
  const rows = data;

  const columnHeaders = Object.keys(columnObject)
    .filter(key => allColKeys.includes(key))
    .reduce((obj, key) => {
      obj[key] = columnObject[key];
      return obj;
    }, {});

  const filteredRows = rows.map(row =>
    Object.keys(row)
      .filter(key => allColKeys.includes(key))
      .reduce((obj, key) => {
        obj[key] = row[key];
        return obj;
      }, {})
  );

  return (
    <TableContainer style={{display: 'none'}} component={Paper}>
      <Table ref={tableRef} sx={{minWidth: 650}}>
        <TableHead>
          <TableRow>
            {Object.values(columnHeaders).map((col, colIndex) => (
              <TableCell key={`head-${colIndex}`}>{col}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredRows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {Object.values(row).map((cell, cellIndex) => (
                <TableCell key={cellIndex} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(cell, {ALLOWED_TAGS: ['strong', 'a', 'i']})}}/>
              ))}
            </TableRow>
          ))}
          <TableRow></TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

TableDataGrid.propTypes = {
  data: PropTypes.array.isRequired,
  tableRef: PropTypes.object.isRequired
};
